import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { clearSuppliers, getSuppliers } from '../../../actions';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';
import SelectFilter from './SelectFilter';

const SupplierFilter = ({
  dispatchGetSuppliers,
  dispatchClearSuppliers,
  options,
  onChangeFilter,
}) => {
  useLayoutEffect(() => {
    dispatchGetSuppliers({
      size: 1000,
    });

    return () => dispatchClearSuppliers();
  }, []);
  return (
    <SelectFilter isMulti onChangeFilter={onChangeFilter} options={options} />
  );
};

SupplierFilter.propTypes = {
  dispatchGetSuppliers: PropTypes.func.isRequired,
  dispatchClearSuppliers: PropTypes.func.isRequired,
  options: optionsPropTypes,
  onChangeFilter: PropTypes.func.isRequired,
};

SupplierFilter.defaultProps = {
  options: [],
};

const mapStateToProps = ({ FoodUnit }) => ({
  options: FoodUnit.Supplier.getIn(['all', 'content', 'content']).map(
    (supplier) => ({
      value: supplier.id,
      label: supplier.business.name,
    }),
  ),
});

const mapDispatchToprops = {
  dispatchGetSuppliers: getSuppliers,
  dispatchClearSuppliers: clearSuppliers,
};

export default connect(mapStateToProps, mapDispatchToprops)(SupplierFilter);
